module.exports = __webpack_public_path__ + "media/images/emblems/Giornico-coat_of_arms-c17a80afb89e066ac3c86d90cc0697be.svg";